import { Component, OnInit, Input } from '@angular/core';
import { FormatoAsistencialEntity, FiltrosFormatoAsistencialEntity } from 'src/app/services/servicio-formato-asistencial.service';

@Component({
  selector: 'app-encabezado-evo',
  templateUrl: './encabezado-evo.component.html',
  styleUrls: ['./encabezado-evo.component.css']
})
export class EncabezadoEvoComponent implements OnInit {

  @Input() public data: FormatoAsistencialEntity;
  @Input() public filtros: FiltrosFormatoAsistencialEntity;
  @Input() public index: number;

  constructor() { }

  ngOnInit() {
  }

  getTitleFormato(){
    return `Evolución - Sesión N°${this.index + 1}`;
  }

  getNombreAfiliado() {
    return this.data.afiliado.primerNombre + ' ' + this.data.afiliado.segundoNombre + ' ' + this.data.afiliado.primerApellido + ' ' + this.data.afiliado.segundoApellido;
  }

  getIdentificacion() {
    return this.data.afiliado.tipoDocumento + '-' + this.data.afiliado.numeroIdentificacion;
  }

  isResponsables() {
    return this.filtros && this.filtros.parametroSimens && this.filtros.parametroSimens.activaResponsable;
  }

  getNumeroDocumento() {
    return this.data.transaccion.prefijo + '-' + this.data.transaccion.consecutivo;
  }

  getSede() {
    const sedeLarga = this.data && this.data.sedePuntoAtencion && this.data.sedePuntoAtencion.sede ? this.data.sedePuntoAtencion.sede.descripcionLarga : '';
    const sedeCorta = this.data && this.data.sedePuntoAtencion && this.data.sedePuntoAtencion.sede ? this.data.sedePuntoAtencion.sede.descripcionCorta : '';
    return sedeLarga ? sedeLarga : sedeCorta;
  }

}
